import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { ApolloProvider } from "@apollo/client";
import { RouterProvider } from "react-router";
import { apolloClient } from "./apollo/client";
import { AuthProvider } from "./auth/AuthProvider";
import { BrandingProvider } from "./branding/BrandingProvider";
import { router } from "./router";
import {
  EnvironmentBanner,
  ENV_BANNER_VISIBLE,
} from "./components/EnvironmentBanner";
import { ImpersonationBanner } from "./components/ImpersonationBanner";
import { ToastProvider } from "./components/ui/Toast";
import { initPostHog } from "./analytics/posthog";
import { PostHogIdentify } from "./analytics/PostHogIdentify";
import "./styles/app.css";

if (ENV_BANNER_VISIBLE) {
  document.documentElement.classList.add("has-env-banner");
}

initPostHog();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ApolloProvider client={apolloClient}>
      <AuthProvider>
        <PostHogIdentify />
        <BrandingProvider>
          <ToastProvider>
            <EnvironmentBanner />
            <ImpersonationBanner />
            <RouterProvider router={router} />
          </ToastProvider>
        </BrandingProvider>
      </AuthProvider>
    </ApolloProvider>
  </StrictMode>,
);
